import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const InputRow = styled.span`
  align-items: center;
  display: flex;
  gap: ${spacing.half};
`;
